import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const FullscreenIcon: FC<IconProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 11V14.293L8.293 11L9 11.707L5.707 15H9V16H4V11H5ZM16 4V9H15V5.707L11.707 9L11 8.293L14.293 5H11V4H16Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);
